import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconSearch = ({ className, color, onClick }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height="34"
    viewBox="0 0 43 44"
    fill="none"
    onClick={onClick}
    color={color}
  >
    <path d="M42.0636 37.5764L33.3741 28.8868C32.8886 28.4013 32.1019 28.4013 31.6164 28.8868L30.7376 29.7656L27.5852 26.6132C27.0997 26.1276 26.313 26.1276 25.8275 26.6132C25.342 27.0987 25.342 27.8853 25.8275 28.3708L28.9799 31.5233L28.1011 32.4021C27.6156 32.8876 27.6156 33.6742 28.1011 34.1598L36.7906 42.8493C37.0334 43.0921 37.3515 43.2135 37.6694 43.2135C37.9874 43.2135 38.3055 43.0921 38.5482 42.8493L42.0636 39.3339C42.5492 38.8484 42.5492 38.0619 42.0636 37.5764Z" fill="url(#search_1)" />
    <path d="M16.159 33.1038C7.24919 33.1038 0 25.8546 0 16.9448C0 8.03496 7.24919 0.785767 16.159 0.785767C25.0689 0.785767 32.3181 8.03496 32.3181 16.9448C32.3181 25.8546 25.0689 33.1038 16.159 33.1038Z" fill="url(#search_2)" />
    <path opacity="0.9" d="M29.8269 15.8037C29.8269 23.5652 23.6775 29.8572 16.0919 29.8572C8.5063 29.8572 2.35693 23.5652 2.35693 15.8037C2.35693 8.04215 7.8339 13.3064 15.4195 13.3064C23.0051 13.3064 30.3876 3.10007 29.8269 15.8037Z" fill="url(#search_3)" />

  </svg>
);

IconSearch.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

IconSearch.defaultProps = {
  className: '',
  color: colors.primary,
  onClick: () => {}
};
